import AppGalleryIcon from '@r1-frontend/ui-react/assets/img/icons/mobileStores/AppGalleryIcon.svg';
import AppGalleryText from '@r1-frontend/ui-react/assets/img/icons/mobileStores/AppGalleryText.svg';
import AppStoreText from '@r1-frontend/ui-react/assets/img/icons/mobileStores/AppStoreText.svg';
import AppStoreWhiteIcon from '@r1-frontend/ui-react/assets/img/icons/mobileStores/AppStoreWhiteIcon.svg';
import GooglePlayIcon from '@r1-frontend/ui-react/assets/img/icons/mobileStores/GooglePlayIcon.svg';
import GooglePlayText from '@r1-frontend/ui-react/assets/img/icons/mobileStores/GooglePlayText.svg';
import RuStoreIcon from '@r1-frontend/ui-react/assets/img/icons/mobileStores/RuStoreIcon.svg';
import RuStoreText from '@r1-frontend/ui-react/assets/img/icons/mobileStores/RuStoreText.svg';

import { EStoreName } from './index';

interface IStoreData {
    link: string,
    title: string,
    store: {
        icon: 'AppStoreIcon' | 'GooglePlayIcon' | 'AppGalleryIcon'| 'RuStoreIcon',
        text: string,
    },
    storeType: 'AppStore' | 'GooglePlay' | 'AppGallery'| 'RuStore',
}

type TData = {
    [key in EStoreName]: IStoreData;
};

export const storeData: TData = {
    AppStore: {
        link: 'https://apps.apple.com/ru/app/%D0%B8%D0%BD%D1%82%D0%B5%D1%80%D0%BD%D0%B5%D1%82-%D0%B4%D0%BE%D0%BC/id6747660359',
        title: 'AppStore',
        store: {
            icon: AppStoreWhiteIcon,
            text: AppStoreText,
        },
        storeType: 'AppStore',
    },
    GooglePlay: {
        link: 'https://play.google.com/store/apps/details?id=com.ertelecom.agent&hl=ru',
        title: 'GooglePlay',
        store: {
            icon: GooglePlayIcon,
            text: GooglePlayText,
        },
        storeType: 'GooglePlay',
    },
    AppGallery: {
        link: 'https://appgallery.huawei.com/app/C101960911',
        title: 'HuaweiAppGallery',
        store: {
            icon: AppGalleryIcon,
            text: AppGalleryText,
        },
        storeType: 'AppGallery',
    },
    MovixAppStore: {
        link: 'https://apps.apple.com/ru/app/dom-ru-tv/id825552263?mt=8&ign-mpt=uo%3D4',
        title: 'MovixAppStore',
        store: {
            icon: AppStoreWhiteIcon,
            text: AppStoreText,
        },
        storeType: 'AppStore',
    },
    MovixGooglePlay: {
        link: 'https://play.google.com/store/apps/details?id=com.ertelecom.domrutv',
        title: 'MovixGooglePlay',
        store: {
            icon: GooglePlayIcon,
            text: GooglePlayText,
        },
        storeType: 'GooglePlay',
    },
    SmartAppStore: {
        link: 'https://apps.apple.com/ru/app/%D0%BC%D0%BE%D0%B9-%D0%B4%D0%BE%D0%BC-%D1%8D%D0%BB%D0%B5%D0%BA%D1%82%D1%80%D0%BE%D0%BD%D0%BD%D1%8B%D0%B9-%D0%B3%D0%BE%D1%80%D0%BE%D0%B4/id1121518319',
        title: 'SmartAppStore',
        store: {
            icon: AppStoreWhiteIcon,
            text: AppStoreText,
        },
        storeType: 'AppStore',
    },
    SmartGooglePlay: {
        link: 'https://play.google.com/store/apps/details?id=com.ertelecom.smarthome',
        title: 'SmartGooglePlay',
        store: {
            icon: GooglePlayIcon,
            text: GooglePlayText,
        },
        storeType: 'GooglePlay',
    },
    RuStore: {
        link: 'https://apps.rustore.ru/app/com.ertelecom.agent',
        title: 'RuStore',
        store: {
            icon: RuStoreIcon,
            text: RuStoreText,
        },
        storeType: 'RuStore',
    },
};
